// Generated from the approved DCC Insights upload pack (12 articles, verbatim copy).
const RAW_ARTICLES = [
  {
    "slug": "choose-commercial-duct-cleaning-partner",
    "title": "How to Choose a Commercial Duct Cleaning Partner",
    "category": "Procurement Guide",
    "serviceId": "all",
    "serviceName": "All DCC Services",
    "meta": "Questions facility and procurement teams should ask when evaluating a commercial duct-cleaning contractor.",
    "standfirst": "Questions facility and procurement teams should ask when evaluating a commercial duct-cleaning contractor.",
    "image": "/assets/dcc/dcc-facility-survey.webp",
    "imageAlt": "DCC surveyor and facility manager reviewing a survey checklist in a commercial kitchen",
    "readMinutes": 3,
    "blocks": [
      {
        "t": "p",
        "text": "Commercial duct cleaning is difficult to evaluate from a quotation alone. Two contractors can use the same service name while proposing very different scopes, access assumptions, methods and evidence standards."
      },
      {
        "t": "h2",
        "text": "1. What exactly is included?"
      },
      {
        "t": "p",
        "text": "Ask the contractor to define system boundaries, not just the visible surfaces."
      },
      {
        "t": "h2",
        "text": "2. How will the system be inspected?"
      },
      {
        "t": "p",
        "text": "The proposal should explain how internal condition will be assessed."
      },
      {
        "t": "h2",
        "text": "3. What access assumptions are being made?"
      },
      {
        "t": "p",
        "text": "Clarify existing access doors, ceiling access, rooftop permission and any new access that may be required."
      },
      {
        "t": "h2",
        "text": "4. Which cleaning method will be used—and why?"
      },
      {
        "t": "p",
        "text": "The answer should relate to the actual duct type and contamination."
      },
      {
        "t": "h2",
        "text": "5. How will the operating facility be protected?"
      },
      {
        "t": "p",
        "text": "Ask about work-zone protection, timing, extraction, waste handling and reinstatement."
      },
      {
        "t": "h2",
        "text": "6. What evidence will be handed over?"
      },
      {
        "t": "p",
        "text": "Define expected photographs, inspection records, checklist, sign-off or other completion documents before award."
      },
      {
        "t": "h2",
        "text": "7. What happens if an issue is found outside scope?"
      },
      {
        "t": "p",
        "text": "A good contractor should record and communicate observations rather than improvise unauthorised work."
      },
      {
        "t": "p",
        "text": "The strongest partner is the one that can explain the system, method, evidence and handover clearly before work begins."
      }
    ]
  },
  {
    "slug": "commercial-air-duct-cleaning-guide",
    "title": "Commercial Air Duct Cleaning: What Facility Teams Should Know",
    "category": "Air Duct Cleaning",
    "serviceId": "air-duct",
    "serviceName": "Commercial Robotic Air Duct Cleaning",
    "meta": "A practical guide to commercial air duct inspection, cleaning, verification and documentation for operating facilities.",
    "standfirst": "A practical guide to commercial air duct inspection, cleaning, verification and documentation for operating facilities.",
    "image": "/assets/dcc/plant-robot.webp",
    "imageAlt": "DCC technician with the robotic inspection crawler in an air-handling plant room",
    "readMinutes": 3,
    "blocks": [
      {
        "t": "p",
        "text": "Commercial air ducts sit out of sight, but they remain part of the building systems that facility teams are responsible for maintaining. Over time, dust and particulate can accumulate inside supply and return ductwork, particularly where maintenance access is limited, filters have failed, construction dust has entered the system, or long service intervals have allowed deposits to build."
      },
      {
        "t": "h2",
        "text": "Start with visibility"
      },
      {
        "t": "p",
        "text": "A proper programme begins with inspection rather than assumptions. A survey should identify system layout, AHU connections, accessible sections, difficult bends, risers, terminal points and existing access doors. Internal inspection—manual or robotic where appropriate—helps establish actual conditions before deciding the cleaning method."
      },
      {
        "t": "h2",
        "text": "Cleaning should match the system"
      },
      {
        "t": "p",
        "text": "Commercial ductwork varies in size, geometry, lining, accessibility and contamination level. The correct method may include mechanical agitation, brushing, vacuum extraction or robotic equipment. The objective is controlled removal of deposits without damaging the system or disrupting the operating facility unnecessarily."
      },
      {
        "t": "h2",
        "text": "Plan around operations"
      },
      {
        "t": "p",
        "text": "Hotels, hospitals, offices, malls and industrial sites rarely have the luxury of long shutdowns. Cleaning therefore needs a defined work window, access plan, site protection approach and coordination with engineering or facility teams."
      },
      {
        "t": "h2",
        "text": "Verification matters"
      },
      {
        "t": "p",
        "text": "A useful handover should make the work visible. Depending on the project, this can include pre-clean inspection images, post-clean images, observations, completion checklists and service documentation. Before-and-after photographs are useful, but they should be taken honestly and from comparable locations where possible."
      },
      {
        "t": "h2",
        "text": "When should a facility consider inspection?"
      },
      {
        "t": "p",
        "text": "Common triggers include visible dust at grilles, suspected contamination following construction, airflow concerns, recurring complaints, long periods without internal inspection, or the need to establish a documented baseline for a maintenance programme."
      },
      {
        "t": "p",
        "text": "Duct cleaning should not be treated as a generic housekeeping activity. It is a technical intervention inside a building system. The better the initial survey and documentation, the more accountable the final result can be."
      }
    ]
  },
  {
    "slug": "commercial-drain-grease-trap-maintenance-guide",
    "title": "Commercial Drain & Grease Trap Cleaning: What Facility Teams Should Monitor",
    "category": "Drain & Grease Trap",
    "serviceId": "drain-grease",
    "serviceName": "Commercial Drain & Grease Trap Cleaning",
    "meta": "A practical guide to monitoring commercial drains and grease traps as part of facility hygiene and operations.",
    "standfirst": "A practical guide to monitoring commercial drains and grease traps as part of facility hygiene and operations.",
    "image": "/assets/insights/commercial-drain-grease-trap.webp",
    "imageAlt": "DCC technician vacuuming a grease-loaded commercial drain channel",
    "readMinutes": 3,
    "blocks": [
      {
        "t": "p",
        "text": "Commercial drains and grease traps are not duct systems, but they are part of the same operational reality: hidden infrastructure can create visible problems when maintenance becomes reactive."
      },
      {
        "t": "h2",
        "text": "Understand the asset first"
      },
      {
        "t": "p",
        "text": "Facility teams should know where grease traps, interceptors, floor drains and key drainage routes are located. Access conditions, cleaning history and recurring problem points should be documented."
      },
      {
        "t": "h2",
        "text": "Watch for operating signals"
      },
      {
        "t": "p",
        "text": "Slow drainage, recurring odour, backup, frequent emergency callouts or excessive grease accumulation can indicate that the current maintenance approach needs review."
      },
      {
        "t": "h2",
        "text": "Controlled cleaning matters"
      },
      {
        "t": "p",
        "text": "Work should be planned to manage the work zone, extraction, hygiene, disposal and reinstatement appropriately for a commercial facility."
      },
      {
        "t": "h2",
        "text": "Build a service history"
      },
      {
        "t": "p",
        "text": "Recording observations, photographs and service dates helps the facility identify recurring patterns and establish a more predictable maintenance plan."
      },
      {
        "t": "p",
        "text": "Drain and grease-trap maintenance works best when it moves from emergency response to planned asset care."
      }
    ]
  },
  {
    "slug": "commercial-kitchen-exhaust-hood-to-rooftop",
    "title": "Commercial Kitchen Exhaust Cleaning Is a Hood-to-Rooftop Job",
    "category": "Kitchen Exhaust",
    "serviceId": "kitchen-exhaust",
    "serviceName": "Commercial Kitchen Exhaust Cleaning",
    "meta": "Why commercial kitchen exhaust cleaning must consider the entire grease-laden path, not only the visible hood.",
    "standfirst": "Why commercial kitchen exhaust cleaning must consider the entire grease-laden path, not only the visible hood.",
    "image": "/assets/dcc/dcc-kitchen-execution.webp",
    "imageAlt": "DCC crew cleaning a kitchen exhaust system under full containment",
    "readMinutes": 3,
    "blocks": [
      {
        "t": "p",
        "text": "The visible hood is only the beginning of a commercial kitchen exhaust system. Behind it sits a path that can include filters, plenum sections, horizontal duct runs, elbows, risers and rooftop exhaust equipment."
      },
      {
        "t": "h2",
        "text": "The hidden part matters"
      },
      {
        "t": "p",
        "text": "A hood can look presentable while deposits remain inside downstream ductwork. That is why a serious survey should look beyond accessible stainless-steel surfaces and understand the full exhaust route."
      },
      {
        "t": "h2",
        "text": "Different sections accumulate differently"
      },
      {
        "t": "p",
        "text": "Straight ductwork, elbows, transitions and vertical sections do not collect residue in exactly the same way. Access limitations can also create sections that are difficult to inspect or clean."
      },
      {
        "t": "h2",
        "text": "Site protection is part of execution"
      },
      {
        "t": "p",
        "text": "Commercial kitchens are operating environments. Work needs to protect cooking equipment, preparation surfaces and surrounding areas. The cleaning team also needs a defined plan for extraction equipment, access and safe reinstatement before the kitchen reopens."
      },
      {
        "t": "h2",
        "text": "Documentation should follow the route"
      },
      {
        "t": "p",
        "text": "Before and after photographs, inspection images, checklists and observations are most useful when they show the system rather than only the easiest visible point."
      },
      {
        "t": "p",
        "text": "Commercial kitchen exhaust cleaning is not just hood polishing. It is specialist cleaning of a grease-laden exhaust system from capture points through the duct route to discharge."
      }
    ]
  },
  {
    "slug": "commercial-laundry-exhaust-duct-cleaning",
    "title": "Laundry Exhaust Duct Cleaning: The Hidden Lint Path",
    "category": "Laundry Exhaust",
    "serviceId": "laundry-exhaust",
    "serviceName": "Commercial Laundry Exhaust Duct Cleaning",
    "meta": "How lint moves through commercial laundry exhaust systems and why inspection of the full duct route matters.",
    "standfirst": "How lint moves through commercial laundry exhaust systems and why inspection of the full duct route matters.",
    "image": "/assets/dcc/laundry-inspect.webp",
    "imageAlt": "DCC technician inspecting a laundry exhaust duct beside commercial dryers",
    "readMinutes": 3,
    "blocks": [
      {
        "t": "p",
        "text": "Commercial laundries generate a continuous lint load. While dryer lint screens capture a significant portion, fine fibres can continue into exhaust connections and ductwork."
      },
      {
        "t": "h2",
        "text": "The visible dryer is only one point"
      },
      {
        "t": "p",
        "text": "A survey should identify the duct path, changes in direction, access points and the final discharge area."
      },
      {
        "t": "h2",
        "text": "Lint behaves differently from grease or dust"
      },
      {
        "t": "p",
        "text": "Laundry exhaust should not be treated as if it were kitchen exhaust or HVAC supply ductwork. The contamination type is different, so the inspection and cleaning method should reflect the actual system."
      },
      {
        "t": "h2",
        "text": "Look for restriction points"
      },
      {
        "t": "p",
        "text": "Bends, transitions, long horizontal sections and difficult-access areas can become important inspection points. The objective is to understand where lint is accumulating rather than assume it is distributed evenly."
      },
      {
        "t": "h2",
        "text": "Plan around laundry operations"
      },
      {
        "t": "p",
        "text": "Cleaning should be coordinated around production schedules and include safe isolation, access, extraction, reinstatement and a documented completion check."
      },
      {
        "t": "p",
        "text": "Laundry exhaust cleaning is specialist duct work. It begins with understanding the complete lint path—not only the equipment visible from the laundry floor."
      }
    ]
  },
  {
    "slug": "duct-access-doors-why-they-matter",
    "title": "Duct Access Doors: Why Cleaning Quality Depends on Access",
    "category": "Technical Guides",
    "serviceId": "all",
    "serviceName": "Commercial Duct Cleaning",
    "meta": "Why commercial duct inspection and cleaning quality depends on having practical, safe access to the system.",
    "standfirst": "Why commercial duct inspection and cleaning quality depends on having practical, safe access to the system.",
    "image": "/assets/insights/real-site-duct-work.webp",
    "imageAlt": "DCC technician installing an access point on a commercial duct run with branded kit",
    "readMinutes": 3,
    "blocks": [
      {
        "t": "p",
        "text": "A duct may be technically cleanable on paper but practically inaccessible on site. Long runs, elbows, risers and concealed sections all depend on suitable access if they are going to be inspected and serviced properly."
      },
      {
        "t": "h2",
        "text": "Access determines visibility"
      },
      {
        "t": "p",
        "text": "Without an opening in the right location, the cleaning team may be unable to inspect a section before work or confirm its condition after work."
      },
      {
        "t": "h2",
        "text": "Existing doors are not always enough"
      },
      {
        "t": "p",
        "text": "Some systems have access points only near equipment or at a small number of locations. Others have doors that are obstructed, damaged or positioned where equipment cannot be used effectively."
      },
      {
        "t": "h2",
        "text": "More access is not automatically better"
      },
      {
        "t": "p",
        "text": "The goal is not to cut unnecessary openings. Access should be planned based on geometry, cleaning method, safety and the need to inspect or reach specific sections."
      },
      {
        "t": "h2",
        "text": "Access affects evidence"
      },
      {
        "t": "p",
        "text": "If the facility expects before-and-after verification, the team must be able to return to representative sections after cleaning."
      },
      {
        "t": "p",
        "text": "Access is not a minor detail. It is one of the factors that determines whether the work can be inspected, executed and verified properly."
      }
    ]
  },
  {
    "slug": "duct-cleaning-evidence-standard",
    "title": "Before & After Is Not Enough: What Duct Cleaning Evidence Should Include",
    "category": "Verification & Evidence",
    "serviceId": "all",
    "serviceName": "All DCC Services",
    "meta": "What a useful commercial duct-cleaning handover can include beyond a few before-and-after photographs.",
    "standfirst": "What a useful commercial duct-cleaning handover can include beyond a few before-and-after photographs.",
    "image": "/assets/dcc/inspect-panel.webp",
    "imageAlt": "DCC technician documenting duct condition with a tablet at an open access panel",
    "readMinutes": 3,
    "blocks": [
      {
        "t": "p",
        "text": "Before-and-after photographs are useful, but they are not the whole evidence story. In commercial facilities, a service handover should help the client understand what was inspected, what was cleaned, what could be verified and what still needs attention."
      },
      {
        "t": "h2",
        "text": "Start with the scope"
      },
      {
        "t": "p",
        "text": "Evidence is meaningful when it connects to a defined area or system. The project should identify which ducts, hoods, risers, access points or assets were included."
      },
      {
        "t": "h2",
        "text": "Capture condition before work"
      },
      {
        "t": "p",
        "text": "Pre-service photographs or inspection images establish a baseline. Where possible, images should be identifiable by location or section."
      },
      {
        "t": "h2",
        "text": "Document execution"
      },
      {
        "t": "p",
        "text": "A smaller, organised set showing access, cleaning method, site protection and key stages can be more useful than an uncontrolled photo dump."
      },
      {
        "t": "h2",
        "text": "Verify after cleaning"
      },
      {
        "t": "p",
        "text": "Post-service images should focus on the same or comparable sections. If the camera angle is different, present them honestly rather than force a misleading slider comparison."
      },
      {
        "t": "h2",
        "text": "Complete the handover"
      },
      {
        "t": "p",
        "text": "Depending on the project, the final pack may include photographs, inspection records, checklists, client sign-off and a service certificate or completion document."
      },
      {
        "t": "p",
        "text": "For Duct Clean Co., evidence is part of the service itself: inspect, clean, verify and document."
      }
    ]
  },
  {
    "slug": "plan-duct-cleaning-operating-hotel",
    "title": "How to Plan Duct Cleaning Around an Operating Hotel",
    "category": "Hospitality",
    "serviceId": "all",
    "serviceName": "All DCC Services",
    "meta": "Practical planning considerations for duct and exhaust cleaning in hotels that must keep operating.",
    "standfirst": "Practical planning considerations for duct and exhaust cleaning in hotels that must keep operating.",
    "image": "/assets/dcc/dcc-site-preparation.webp",
    "imageAlt": "DCC technicians preparing containment and equipment before execution",
    "readMinutes": 3,
    "blocks": [
      {
        "t": "p",
        "text": "Hotels rarely stop operating because engineering work is scheduled. Kitchens need to reopen for breakfast, guestrooms remain occupied, banquet spaces may change overnight and public areas cannot look like work zones in the morning."
      },
      {
        "t": "h2",
        "text": "Confirm the operating window"
      },
      {
        "t": "p",
        "text": "Start with the real shutdown time available. Kitchen close-down, equipment cooling, security access and morning reopening can reduce the usable work window."
      },
      {
        "t": "h2",
        "text": "Define access before the team arrives"
      },
      {
        "t": "p",
        "text": "Ceiling access, duct access doors, plant-room keys, rooftop permission and back-of-house routes should be confirmed in advance."
      },
      {
        "t": "h2",
        "text": "Protect the facility"
      },
      {
        "t": "p",
        "text": "Protection and reinstatement should be part of the method statement, not an afterthought."
      },
      {
        "t": "h2",
        "text": "Coordinate stakeholders"
      },
      {
        "t": "p",
        "text": "Engineering, security, kitchen or laundry operations and housekeeping may all be affected. One client-side point of contact helps avoid conflicting instructions."
      },
      {
        "t": "h2",
        "text": "Plan the evidence before the work"
      },
      {
        "t": "p",
        "text": "Agree what completion evidence is required before award so important proof is captured during execution."
      },
      {
        "t": "p",
        "text": "In hospitality, the best technical work is completed properly while the guest experience remains largely unaware that it happened."
      }
    ]
  },
  {
    "slug": "robotic-air-duct-inspection-before-cleaning",
    "title": "Why Robotic Air Duct Cleaning Starts With Inspection",
    "category": "Robotics & Inspection",
    "serviceId": "air-duct",
    "serviceName": "Commercial Robotic Air Duct Cleaning",
    "meta": "Why commercial duct cleaning should begin with internal inspection, visibility and a defined cleaning plan.",
    "standfirst": "Why commercial duct cleaning should begin with internal inspection, visibility and a defined cleaning plan.",
    "image": "/assets/dcc/robot-tech.webp",
    "imageAlt": "DCC technician operating the robotic duct-cleaning crawler",
    "readMinutes": 3,
    "blocks": [
      {
        "t": "p",
        "text": "Most commercial ductwork cannot be assessed properly from the outside. A grille may look clean while deposits remain deeper in the system; equally, a facility may assume contamination is widespread when the issue is concentrated in a limited section. Robotic inspection helps replace guesswork with visibility."
      },
      {
        "t": "h2",
        "text": "You cannot plan what you cannot see"
      },
      {
        "t": "p",
        "text": "Internal cameras can help teams understand the condition of long duct runs, bends and difficult-to-access areas before cleaning begins. This allows the scope to be based on evidence rather than a generic assumption."
      },
      {
        "t": "h2",
        "text": "Inspection improves access planning"
      },
      {
        "t": "p",
        "text": "Existing access doors may not be positioned where inspection or cleaning is needed. A survey can identify where additional access may be required and where equipment can work effectively without unnecessary disturbance to ceilings or surrounding finishes."
      },
      {
        "t": "h2",
        "text": "Robotics is a tool, not the strategy"
      },
      {
        "t": "p",
        "text": "Robotic equipment can be valuable for internal visibility and mechanical cleaning in suitable duct sizes and geometries. It should not be presented as a gimmick or used where another method is more appropriate. The method should follow the system condition, dimensions, accessibility and project objective."
      },
      {
        "t": "h2",
        "text": "Verification can use the same visibility"
      },
      {
        "t": "p",
        "text": "Internal inspection is equally useful after cleaning. Returning to the same sections provides a more credible comparison and supports documented handover."
      },
      {
        "t": "p",
        "text": "A stronger commercial workflow is: survey, inspect, define access, select the method, execute, verify and document."
      }
    ]
  },
  {
    "slug": "signs-commercial-hvac-ducts-need-inspection",
    "title": "7 Signs Your Commercial HVAC Ducts Need Inspection",
    "category": "Air Duct Cleaning",
    "serviceId": "air-duct",
    "serviceName": "Commercial Robotic Air Duct Cleaning",
    "meta": "Seven practical triggers that can justify a closer look inside commercial HVAC ductwork.",
    "standfirst": "Seven practical triggers that can justify a closer look inside commercial HVAC ductwork.",
    "image": "/assets/dcc/crew-ready.webp",
    "imageAlt": "DCC technician ready inside a contained commercial facility",
    "readMinutes": 3,
    "blocks": [
      {
        "t": "p",
        "text": "Commercial ductwork is normally hidden above ceilings, inside shafts and behind plant-room connections. Because it is out of sight, facilities often wait for a complaint before checking internal conditions."
      },
      {
        "t": "h2",
        "text": "1. Visible dust around diffusers or grilles"
      },
      {
        "t": "p",
        "text": "Repeated deposition can justify a closer look at upstream sections."
      },
      {
        "t": "h2",
        "text": "2. Construction or renovation activity"
      },
      {
        "t": "p",
        "text": "Refurbishment and fit-outs can introduce particulate into building systems if openings and return paths were not fully protected."
      },
      {
        "t": "h2",
        "text": "3. A long period without internal inspection"
      },
      {
        "t": "p",
        "text": "If the facility does not have a recent internal condition record, inspection can establish a baseline."
      },
      {
        "t": "h2",
        "text": "4. Airflow complaints"
      },
      {
        "t": "p",
        "text": "Poor airflow can have many causes. Duct condition is only one possible factor, but inspection can help rule it in or out."
      },
      {
        "t": "h2",
        "text": "5. Recurring occupant complaints"
      },
      {
        "t": "p",
        "text": "Dust, odour or comfort complaints should be investigated systematically. Duct inspection can be one part of that process."
      },
      {
        "t": "h2",
        "text": "6. Moisture or contamination events"
      },
      {
        "t": "p",
        "text": "Water ingress, condensation issues or other events may justify targeted inspection."
      },
      {
        "t": "h2",
        "text": "7. A major maintenance or handover milestone"
      },
      {
        "t": "p",
        "text": "Refurbishments, asset handovers or planned engineering shutdowns are useful opportunities to document systems that are normally inaccessible."
      },
      {
        "t": "p",
        "text": "Inspection does not automatically mean cleaning is required. That is the point: an evidence-led assessment helps the facility decide what action is justified."
      }
    ]
  },
  {
    "slug": "survey-plan-execute-verify-handover",
    "title": "Survey to Handover: A Better Process for Commercial Duct Cleaning",
    "category": "DCC Method",
    "serviceId": "all",
    "serviceName": "All DCC Services",
    "meta": "Why a five-stage Survey → Plan → Execute → Verify → Handover process creates more accountable commercial duct cleaning.",
    "standfirst": "Why a five-stage Survey → Plan → Execute → Verify → Handover process creates more accountable commercial duct cleaning.",
    "image": "/assets/insights/kitchen-team-reviewing-tablet.webp",
    "imageAlt": "DCC supervisor and facility engineer reviewing documentation on a tablet in a commercial kitchen",
    "readMinutes": 3,
    "blocks": [
      {
        "t": "p",
        "text": "Commercial duct cleaning becomes more predictable when it is treated as a defined project rather than a one-night activity."
      },
      {
        "t": "h2",
        "text": "1. Survey"
      },
      {
        "t": "p",
        "text": "Understand the facility, system route, operating constraints, contamination indicators and available access."
      },
      {
        "t": "h2",
        "text": "2. Plan"
      },
      {
        "t": "p",
        "text": "Convert the survey into a practical scope: work zones, access sequence, team, equipment, protection, timing and handover requirements."
      },
      {
        "t": "h2",
        "text": "3. Execute"
      },
      {
        "t": "p",
        "text": "Carry out the work using methods suited to the actual system, with site protection, safe access and disciplined section-by-section cleaning."
      },
      {
        "t": "h2",
        "text": "4. Verify"
      },
      {
        "t": "p",
        "text": "Check cleaned sections using visual or camera inspection as appropriate. Verification should answer a simple question: can we show what changed?"
      },
      {
        "t": "h2",
        "text": "5. Handover"
      },
      {
        "t": "p",
        "text": "Close the job with organised evidence and clear client communication. Record observations outside the cleaning scope for follow-up."
      },
      {
        "t": "p",
        "text": "This sequence creates a single accountable process from first visit to final completion."
      }
    ]
  },
  {
    "slug": "why-grease-builds-up-beyond-kitchen-hood",
    "title": "Why Grease Builds Up Beyond the Kitchen Hood",
    "category": "Kitchen Exhaust",
    "serviceId": "kitchen-exhaust",
    "serviceName": "Commercial Kitchen Exhaust Cleaning",
    "meta": "A facility-focused explanation of how cooking vapour carries grease into hidden exhaust ductwork.",
    "standfirst": "A facility-focused explanation of how cooking vapour carries grease into hidden exhaust ductwork.",
    "image": "/assets/dcc/dcc-kitchen-survey.webp",
    "imageAlt": "DCC technician sealing a kitchen exhaust canopy — grease travels beyond the hood",
    "readMinutes": 3,
    "blocks": [
      {
        "t": "p",
        "text": "When food is cooked at commercial scale, heat and vapour rise into the kitchen exhaust system. Filters capture part of that load, but the system continues beyond the hood. Fine grease aerosols and residue can travel into the plenum and downstream ductwork before the air reaches the final discharge point."
      },
      {
        "t": "h2",
        "text": "The duct is part of the exhaust system"
      },
      {
        "t": "p",
        "text": "From a maintenance perspective, hood, plenum, duct and fan should be understood as one route. Cleaning only the visible section can leave the hidden system undocumented."
      },
      {
        "t": "h2",
        "text": "Geometry influences deposits"
      },
      {
        "t": "p",
        "text": "Changes in direction, joints, horizontal runs and areas of reduced access can accumulate residue differently. That makes inspection important before a cleaning plan is finalised."
      },
      {
        "t": "h2",
        "text": "Operating conditions differ"
      },
      {
        "t": "p",
        "text": "A hotel banquet kitchen, QSR, bakery and restaurant do not have identical operating loads. Cooking type, hours, system design and previous maintenance all influence internal condition."
      },
      {
        "t": "h2",
        "text": "Evidence helps future planning"
      },
      {
        "t": "p",
        "text": "Internal photographs and observations can help engineering teams understand which sections are accessible, where deposits were significant and where future monitoring should focus."
      },
      {
        "t": "p",
        "text": "The key idea is simple: what happens above the cooking line continues beyond the hood."
      }
    ]
  }
];

// Editorial metadata. Publish dates supplied and verified by the site owner
// (2026-08-30); dateModified stays empty until an article is actually revised.
const PUBLISH_DATES = {
  "choose-commercial-duct-cleaning-partner": "2021-01-22",
  "commercial-air-duct-cleaning-guide": "2021-02-18",
  "commercial-drain-grease-trap-maintenance-guide": "2021-12-10",
  "commercial-kitchen-exhaust-hood-to-rooftop": "2022-03-30",
  "commercial-laundry-exhaust-duct-cleaning": "2022-10-18",
  "duct-access-doors-why-they-matter": "2023-01-15",
  "duct-cleaning-evidence-standard": "2023-11-01",
  "plan-duct-cleaning-operating-hotel": "2024-04-01",
  "robotic-air-duct-inspection-before-cleaning": "2024-08-23",
  "signs-commercial-hvac-ducts-need-inspection": "2025-07-25",
  "survey-plan-execute-verify-handover": "2026-05-10",
  "why-grease-builds-up-beyond-kitchen-hood": "2026-06-22",
};

// Display formatter for ISO dates — "22 Jan 2021".
export const fmtDate = (iso) =>
  new Date(`${iso}T00:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });

// Search-result titles (≤60 chars) — the full article title stays as the H1;
// these are only what Google shows. Keeps brand suffix without truncation.
const ARTICLE_SEO_TITLES = {
  "choose-commercial-duct-cleaning-partner": "How to Choose a Commercial Duct Cleaning Partner | DCC",
  "commercial-air-duct-cleaning-guide": "Commercial Air Duct Cleaning: Facility Guide | DCC",
  "commercial-drain-grease-trap-maintenance-guide": "Commercial Drain & Grease Trap Cleaning Guide | DCC",
  "commercial-kitchen-exhaust-hood-to-rooftop": "Kitchen Exhaust Cleaning Is Hood-to-Rooftop | DCC",
  "commercial-laundry-exhaust-duct-cleaning": "Laundry Exhaust Duct Cleaning: Hidden Lint Path | DCC",
  "duct-access-doors-why-they-matter": "Duct Access Doors: Quality Depends on Access | DCC",
  "duct-cleaning-evidence-standard": "What Duct Cleaning Evidence Should Include | DCC",
  "plan-duct-cleaning-operating-hotel": "Plan Duct Cleaning Around an Operating Hotel | DCC",
  "robotic-air-duct-inspection-before-cleaning": "Robotic Air Duct Cleaning Starts With Inspection | DCC",
  "signs-commercial-hvac-ducts-need-inspection": "7 Signs Commercial HVAC Ducts Need Inspection | DCC",
  "survey-plan-execute-verify-handover": "Survey to Handover: Better Duct Cleaning Process | DCC",
  "why-grease-builds-up-beyond-kitchen-hood": "Why Grease Builds Up Beyond the Kitchen Hood | DCC",
};
// Intrinsic cover-image dimensions (measured from source files) for CLS-safe
// width/height attributes on every card.
const IMG_DIMS = {
  "/assets/dcc/dcc-facility-survey.webp": [2048, 1149],
  "/assets/dcc/plant-robot.webp": [2000, 927],
  "/assets/insights/commercial-drain-grease-trap.webp": [1600, 897],
  "/assets/dcc/dcc-kitchen-execution.webp": [1400, 1400],
  "/assets/dcc/laundry-inspect.webp": [1600, 733],
  "/assets/insights/real-site-duct-work.webp": [1600, 1470],
  "/assets/dcc/inspect-panel.webp": [1600, 898],
  "/assets/dcc/dcc-site-preparation.webp": [1600, 898],
  "/assets/dcc/robot-tech.webp": [1600, 1122],
  "/assets/dcc/crew-ready.webp": [1600, 738],
  "/assets/insights/kitchen-team-reviewing-tablet.webp": [1600, 610],
  "/assets/dcc/dcc-kitchen-survey.webp": [1400, 1287],
};

export const ARTICLES = RAW_ARTICLES.map((a) => {
  const [imageW, imageH] = IMG_DIMS[a.image] || [1600, 900];
  return {
    author: "DCC Technical Team",
    authorRole: "Technical content, Duct Clean Co.",
    reviewer: "DCC Engineering & Quality",
    datePublished: PUBLISH_DATES[a.slug] || "",
    seoTitle: ARTICLE_SEO_TITLES[a.slug] || "",
    dateModified: "",
    imageW,
    imageH,
    ...a,
  };
});
